<input
    #input
    type="text"
    [value]="value"
    (input)="onInput($event)"
    [class.border-pending]="isPending"
    class="calc-textbox"
    placeholder="?"
    [disabled]="disabled"
    (keyup.enter)="onEnter($event)"
    (keyup.esc)="onEsc($event)"
    (blur)="onBlur($event)"
    (focus)="input.select()"
/>
